class ArticleCarousel {
    constructor(carousel) {
        this.slideIndex = 1;
        this.slides = carousel.getElementsByClassName("mySlides");
        this.prev = carousel.getElementsByClassName("prev")[0];
        this.next = carousel.getElementsByClassName("next")[0];

        this.prev.classList.add("disabled");
        this.prev.setAttribute("aria-disabled", true);

        this.showSlides(this.slideIndex);
    }

    scrollSlides(n) {
        let nextSlideIndex = this.slideIndex + n;
        if (nextSlideIndex != this.slides.length + 1 || nextSlideIndex != 0) {
            this.showSlides(this.slideIndex += n)
        }

        if (this.slideIndex == 1) {
            this.prev.classList.add("disabled");
            this.prev.setAttribute("aria-disabled", true);
        }else if (this.slideIndex == this.slides.length) {
            this.next.classList.add("disabled");
            this.next.setAttribute("aria-disabled", true);
        }else {
            this.prev.classList.remove("disabled");
            this.next.classList.remove("disabled");
            this.prev.setAttribute("aria-disabled", false);
            this.next.setAttribute("aria-disabled", false);
        }
    }

    showSlides(n) {
        if (n > this.slides.length) {this.slideIndex = this.slides.length}
        if (n < 1) {this.slideIndex = 1}

        for (let i = 0; i < this.slides.length; i++) {
            this.slides[i].style.display = "none";
        }
        this.slides[this.slideIndex - 1].style.display = "block";
    }
}

export const initialiseArticleCarousel = () => {
    document.querySelectorAll(".coop-c-article__carousel-image").forEach((carousel) => {
        const articleCarousel = new ArticleCarousel(carousel);

        articleCarousel.prev.addEventListener('click', () => { articleCarousel.scrollSlides(-1) });
        articleCarousel.next.addEventListener('click', () => { articleCarousel.scrollSlides(1) });
    });
}